import React, { useEffect } from 'react';

import {
  Check,
  CheckCircle,
  Cube,
  Database,
  Minus,
  Users,
} from '@phosphor-icons/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'src/components/Button';
import { ContactSales } from 'src/components/ContactSales';
import { Head } from 'src/components/Head';
import { ThumbBottom } from 'src/components/Thumb/styles';
import { Title } from 'src/components/Title/styles';
import light from 'src/styles/themes/light';
import {
  TrackGoogleAnalyticsEvent,
  TrackGoogleAnalyticsPageView,
} from 'src/utils/google-analytics';

import {
  CheckList,
  Container,
  Content,
  Divider,
  FeatureType,
  MobileContent,
  PlanColumn,
  PlansType,
  Table,
} from './styles';

export function Plans() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    TrackGoogleAnalyticsPageView(location.pathname, 'Tela de Planos');
  }, [location.pathname]);

  return (
    <Container>
      <Head
        title="Planos | 4intelligence"
        description="Conheça nossos planos. Veja qual plano funciona melhor para o seu negócio."
      />

      <ThumbBottom />

      <Title>
        <h3>Conheça nossos planos</h3>

        <h1>Veja qual plano funciona melhor para o seu negócio</h1>
      </Title>

      <Content>
        <Table>
          <thead>
            <tr>
              <th aria-label="nome da coluna vazia" />
              <th>
                <PlansType>
                  <h2>Free</h2>
                  <p>Acesso restrito à nossa base de dados integrada</p>

                  <Button
                    buttonType="tertiary"
                    onClick={() => {
                      TrackGoogleAnalyticsEvent(
                        'Comece grátis',
                        'Ir para cadastro do freemium',
                        location.pathname,
                      );
                      navigate('/freemium/sign-up');
                    }}
                    data-testid="start-free-button"
                  >
                    Comece grátis!
                  </Button>
                </PlansType>
              </th>
              <th>
                <PlansType>
                  <h2>Business</h2>
                  <p>Obtenha a experiência completa da 4intelligence</p>

                  <Button
                    buttonType="primary"
                    onClick={() => {
                      TrackGoogleAnalyticsEvent(
                        'Falar com vendas',
                        'Ir para tela Falar com Vendas',
                        location.pathname,
                      );
                      navigate('/contact-sales');
                    }}
                    data-testid="contact-sales-plans-button"
                  >
                    Falar com vendas
                  </Button>
                </PlansType>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-title">
              <td style={{ color: light.colors.secondary }}>
                <Database weight="duotone" color={light.colors.secondary} />
                Feature Store
              </td>

              <td aria-label="campo da tabela vazio" />
              <td aria-label="campo da tabela vazio" />
            </tr>

            <tr className="table-background">
              <td>
                Dados macroeconômicos e de diversos setores prontos para uso
              </td>
              <td style={{ fontWeight: 500 }}>Restrito</td>
              <td style={{ fontWeight: 500, color: light.colors.primary }}>
                +100 mil
              </td>
            </tr>

            <tr>
              <td>Atualização automática de dados</td>
              <td>
                <Check weight="bold" color={light.colors.primary} />
              </td>
              <td>
                <Check weight="bold" color={light.colors.primary} />
              </td>
            </tr>

            <tr className="table-background">
              <td>
                Projeções confiáveis feitas por IA e validadas por especialistas
              </td>
              <td>
                <Check weight="bold" color={light.colors.primary} />
              </td>
              <td>
                <Check weight="bold" color={light.colors.primary} />
              </td>
            </tr>

            <tr>
              <td>
                Chat 4i, IA para explorar a conexão dos dados com seu negócio
              </td>
              <td>
                <Check weight="bold" color={light.colors.primary} />
              </td>
              <td>
                <Check weight="bold" color={light.colors.primary} />
              </td>
            </tr>

            <tr className="table-title">
              <td style={{ color: light.colors.primary }}>
                <Cube weight="duotone" color={light.colors.primary} />
                Models
              </td>

              <td aria-label="campo da tabela vazio" />
              <td aria-label="campo da tabela vazio" />
            </tr>

            <tr className="table-background">
              <td>
                Construção de modelos de série de tempo para prever tendências
              </td>
              <td>
                <Minus weight="bold" color={light.colors.gray4} />
              </td>
              <td>
                <Check weight="bold" color={light.colors.primary} />
              </td>
            </tr>

            <tr>
              <td>
                Algoritmos de classificação para segmentação e análise de risco
              </td>
              <td>
                <Minus weight="bold" color={light.colors.gray4} />
              </td>
              <td>
                <Check weight="bold" color={light.colors.primary} />
              </td>
            </tr>

            <tr className="table-background">
              <td>Conciliação de acurácia e explicabilidade</td>
              <td>
                <Minus weight="bold" color={light.colors.gray4} />
              </td>
              <td>
                <Check weight="bold" color={light.colors.primary} />
              </td>
            </tr>

            <tr>
              <td>Seleção automática de dados que aumentam acurácia</td>
              <td>
                <Minus weight="bold" color={light.colors.gray4} />
              </td>
              <td>
                <Check weight="bold" color={light.colors.primary} />
              </td>
            </tr>

            <tr className="table-title">
              <td style={{ color: light.colors.gray5 }}>
                <Users color={light.colors.gray5} />
                Suporte
              </td>

              <td aria-label="campo da tabela vazio" />
              <td aria-label="campo da tabela vazio" />
            </tr>

            <tr className="table-background">
              <td>Assistência com especialistas em inteligência econômica</td>
              <td>
                <Minus weight="bold" color={light.colors.gray4} />
              </td>
              <td>
                <Check weight="bold" color={light.colors.primary} />
              </td>
            </tr>
          </tbody>
        </Table>
      </Content>

      <MobileContent>
        <PlanColumn>
          <PlansType>
            <h2>Free</h2>
            <p>Acesso restrito à nossa base de dados integrada</p>

            <Button
              buttonType="tertiary"
              onClick={() => {
                TrackGoogleAnalyticsEvent(
                  'Comece grátis',
                  'Ir para cadastro do freemium',
                  location.pathname,
                );
                navigate('/freemium/sign-up');
              }}
              data-testid="start-free-mobile-button"
            >
              Comece grátis!
            </Button>
          </PlansType>

          <Divider />

          <FeatureType style={{ color: light.colors.secondary }}>
            <Database weight="duotone" color={light.colors.secondary} />
            Feature Store
          </FeatureType>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>
              Dados macroeconômicos e de diversos setores prontos para uso{' '}
              <span>(Restrito)</span>
            </p>
          </CheckList>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>Atualização automática de dados</p>
          </CheckList>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>
              Projeções confiáveis feitas por IA e validadas por especialistas
            </p>
          </CheckList>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>Chat 4i, IA para explorar a conexão dos dados com seu negócio</p>
          </CheckList>
        </PlanColumn>

        <PlanColumn>
          <PlansType>
            <h2>Business</h2>
            <p>Obtenha a experiência completa da 4intelligence</p>

            <Button
              buttonType="primary"
              onClick={() => {
                TrackGoogleAnalyticsEvent(
                  'Falar com vendas',
                  'Ir para tela Falar com Vendas',
                  location.pathname,
                );
                navigate('/contact-sales');
              }}
              data-testid="contact-sales-plans-mobile-button"
            >
              Falar com vendas
            </Button>
          </PlansType>

          <Divider />

          <FeatureType style={{ color: light.colors.secondary }}>
            <Database weight="duotone" color={light.colors.secondary} />
            Feature Store
          </FeatureType>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>
              Dados macroeconômicos e de diversos setores prontos para uso{' '}
              <span>(+100 mil)</span>
            </p>
          </CheckList>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>Atualização automática de dados</p>
          </CheckList>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>
              Projeções confiáveis feitas por IA e validadas por especialistas
            </p>
          </CheckList>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>Chat 4i, IA para explorar a conexão dos dados com seu negócio</p>
          </CheckList>

          <FeatureType
            style={{ color: light.colors.primary, marginTop: '3rem' }}
          >
            <Cube weight="duotone" color={light.colors.primary} />
            Models
          </FeatureType>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>
              Construção de modelos de série de tempo para prever tendências
            </p>
          </CheckList>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>
              Algoritmos de classificação para segmentação e análise de risco
            </p>
          </CheckList>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>Conciliação de acurácia e explicabilidade</p>
          </CheckList>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>Seleção automática de dados que aumentam acurácia</p>
          </CheckList>

          <FeatureType style={{ color: light.colors.gray5, marginTop: '3rem' }}>
            <Users color={light.colors.gray5} />
            Suporte
          </FeatureType>

          <CheckList>
            <CheckCircle weight="fill" color={light.colors.primary} />
            <p>Assistência com especialistas em inteligência econômica</p>
          </CheckList>
        </PlanColumn>
      </MobileContent>

      <ContactSales />
    </Container>
  );
}
